import { createI18n } from 'vue-i18n';
import en from './locales/en';
// Czech is disabled for now — re-enable by uncommenting the `cs` lines below.
// import cs from './locales/cs';

export type Locale = 'en'; // | 'cs'

// `label` is the language's own native name (shown in the switcher).
export const LOCALES: { code: Locale; label: string; short: string }[] = [
  { code: 'en', label: 'English', short: 'EN' },
  // { code: 'cs', label: 'Čeština', short: 'CS' },
];

const STORAGE_KEY = 'ogk_locale';

function detectLocale(): Locale {
  // Only English is offered while Czech is disabled; ignore a saved `cs`
  // and the browser language.
  return 'en';
  // const saved = localStorage.getItem(STORAGE_KEY);
  // if (saved === 'en' || saved === 'cs') return saved;
  // const nav = (navigator.language || '').toLowerCase();
  // return nav.startsWith('cs') ? 'cs' : 'en';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en /* , cs */ },
});

export function setLocale(locale: Locale) {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

// Reflect the active locale on <html lang> from the first paint.
document.documentElement.lang = i18n.global.locale.value;
